module.exports = __webpack_public_path__ + "static/media/img167.2e4e7278.jpg";